import { Outlet } from "react-router";

export const InvoicesLayout = () => {
  return <Outlet />;
};
